import {FC} from 'react';
import {styled} from 'styled-components';
import {Route} from 'wouter';

import {AppBottomNavigation} from '@website_frontend/components/bottom_navigation';
import {HomePage} from '@website_frontend/components/home_page';
import LeafletCss from '@website_frontend/components/leaflet_css';
import {LikedPage} from '@website_frontend/components/liked_page';
import {SearchesPage} from '@website_frontend/components/searches_page';
import {DbDataProvider} from '@website_frontend/lib/db_cache';

export const App: FC = () => {
  return (
    <DbDataProvider>
      <Wrapper>
        <Route path="/" component={HomePage} />
        <Route path="/liked" component={LikedPage} />
        <Route path="/searches" component={SearchesPage} />
      </Wrapper>
      <AppBottomNavigation />
      <LeafletCss />
    </DbDataProvider>
  );
};
App.displayName = 'App';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 56px; // bottom navigation height
  left: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: #ccc;
`;
